/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * Shows a button that provides location capabilities.
 *
 * @example
 * ```javascript
 * var widget = (new L.Location()).addTo(map);
 *
 * widget.on(L.Location.Events.LocationFound, function (event) {
 *   console.log('LocationFound');
 *   console.log(event);
 * });
 *
 * widget.on(L.Location.Events.LocationError, function (event) {
 *   console.log('LocationError');
 *   console.log(event);
 * });
 *
 * @class Location
 * @namespace L
 * @extends L.Control
 * @uses L.Evented
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {String} [options.imageSrc=null] The image path for locate button. If this option is passed the button would
 *     be created as an `<img>` tag.
 * @param {Number[]} [options.size=[34,34]] Its an array of two integers (width, height).
 *     The default size of the icon will be double if the user's device has a screen with Retina display capability.
 *     Allows to change size of the image, a useful option for SVG images.
 * @param {String} [options.className=""] The class name of the container element.
 *     With this option an external icon library (i.e. Font Awesome) could be used for widget's button.
 */
define(['display/map', 'services/utils'], function(L, Utils) {
    'use strict';

    var EVENTS = {
        LocationFound: 'locationFound',
        LocationError: 'locationError'
    };

    function getClassName(options) {
        return options.className || options.imageSrc ? options.className : 'icon-locate_me_btn';
    }

    function setSizeStyle(style, size) {
        if (size) {
            style.width = size[0] + 'px';
            style.height = size[1] + 'px';
            style.backgroundSize = size[0] + 'px ' + size[1] + 'px';
        }
    }

    L.Location = L.Control.extend({

        includes: L.Evented.prototype,

        options: {
            imageSrc: null,
            size: L.Browser.retina ? [57, 57] : [34, 34],
            className: ''
        },

        createContainer: function() {
            var className = getClassName(this.options),
                container = L.DomUtil.create('div', 'leaflet-control-location ' + className),
                img;
            setSizeStyle(container.style, this.options.size);
            container.style.cursor = 'pointer';
            if (!L.Browser.svg || this.options.imageSrc) {
                img = L.DomUtil.create('img', '', container);
                img.src = this.options.imageSrc || L.Icon.Default.imagePath + '/locate_me_btn.png';
                img.style.cursor = 'pointer';
            }
            return container;
        },

        /**
         * The method to instantiates the location control.
         * Executed when adding to map.
         *
         * @ignore
         * @method onAdd
         * @param {Object} map Leaflet map to add control to.
         * @return {HTMLElement}
         */
        onAdd: function(map) {
            var container = this.createContainer();
            var control = this;

            L.DomEvent.addListener(container, 'mousedown', map.locate, map);
            map.on('locationfound', function(location) {
                control.fire(EVENTS.LocationFound, location);
            });
            map.on('locationerror', function(error) {
                control.fire(EVENTS.LocationError, error);
            });
            return container;
        },
        /**
         * Event that is fired when obtaining user's current location succeed.
         *
         * @event LocationFound
         * @param {Object} eventObject The found
         *     <a href="http://leafletjs.com/reference-1.0.3.html#locationevent-property"
         *     target="_blank">location details</a>
         * @param {String} [type="locationFound"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var widget = (new L.Location()).addTo(map);
         * widget.on(L.Location.Events.LocationFound, function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when obtaining user's current location fails.
         *
         * @event LocationError
         * @param {Object} eventObject All failure information
         * @param {String} [type="locationError"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         *
         * var widget = (new L.Location()).addTo(map);
         * widget.on(L.Location.Events.LocationError, function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        Events: EVENTS,
        statics: {
            Events: EVENTS
        }
    });

    return function(options) {
        var location = new L.Location(options);
        Utils.addDeprecatedProperty(location, 'Event', 'Events');
        return location;
    };
});



// WEBPACK FOOTER //
// ./widgets/controls/location.js